<template>
  <div class="row">
    <div 
      v-for="type in types" 
      :key="type.id" 
      class="col-xs-12 col-sm-4">
      <div class="box p-a">
        <transition 
          name="fade" 
          mode="out-in">
          <div 
            key="content" 
            class="content">
            <div class="pull-left m-r">
              <span :class="type.class">
                <i 
                  class="material-icons" 
                  v-html="type.icon"/>
              </span>
            </div>
            <div class="clear">
              <span>
                <h4 class="m-a-0 text-lg _300">
                  {{ Currency }} 
                  <span v-if="!loading">{{ new Intl.NumberFormat('en', {minimumFractionDigits: 2}).format(type.total) }}</span>
                  <small 
                    v-show="loading" 
                    class="text-xs"><i class="fa fa-spinner fa-spin fa-2x"/></small>
                </h4>
              </span>
              <small class="text-muted">{{ type.name }}</small>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Laravel from '../../laroute';

export default {
    props: {
        Currency: {
            type: String,
            default: 'RM',
        },
    },

    data() {
        return {
            loading: true,
            types: [
                {
                    id: 'taxable_sales',
                    name: 'Taxable Sales',
                    total: null,
                    class: 'w-48 rounded accent',
                    icon: '&#xe227;',
                },
                {
                    id: 'none_taxable_sales',
                    name: 'Non-Taxable Sales',
                    total: null,
                    class: 'w-48 rounded info',
                    icon: '&#xE25C;',
                },
                {
                    id: 'net_sales',
                    name: 'Net Sales',
                    total: null,
                    class: 'w-48 rounded primary',
                    icon: '&#xE24A;',
                },
            ],
        };
    },

    computed: {
        ...mapGetters(['dateFilter']),
        ...mapState('tillFilter', ['filters']),

        api() {
            return Laravel.route('franchise.report.tax.getTaxSummary', {
                id: this.outlet,
            });
        },

        outlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    watch: {
        outlet() {
            this.getTaxSummary();
        },

        dateFilter(a, b) {
            if (a == b) return;
            this.getTaxSummary();
        },

        filters: function(to, from) {
            if (to === from) return;
            this.getTaxSummary();
        },
    },

    mounted() {
        this.getTaxSummary();
    },

    methods: {
        getTaxSummary() {
            this.loading = true;

            let options = {
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
                filters: this.filters,
            };

            this.$http.get(this.api, { params: options }).then(response => {
                var data = response.data.data;
                this.types = this.types.map(obj => {
                    obj.total = data[obj.id];
                    return obj;
                });

                this.loading = false;
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/tax/tax_box_summary.vue